import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Slide extends Vue {
    @Prop() readonly data!: any;
    @Prop() readonly section!: any;

    get overview(): any {
        return this.data.overview;
    }

    get overviewC1(): any {
        return this.data.overviewC1;
    }

    get overviewC2(): any {
        return this.data.overviewC2;
    }

    get profitloss(): any {
        return this.data.profitloss;
    }

    get profitlossC1(): any {
        return this.data.profitlossC1;
    }

    get profitlossC2(): any {
        return this.data.profitlossC2;
    }

    get balance(): any {
        return this.data.balance;
    }

    get balanceC1(): any {
        return this.data.balanceC1;
    }

    get balanceC2(): any {
        return this.data.balanceC2;
    }

    get ranking(): any {
        return this.data.ranking;
    }

    get rankingC1(): any {
        return this.data.rankingC1;
    }

    get rankingC2(): any {
        return this.data.rankingC2;
    }
}
